import { render, staticRenderFns } from "./ItemPriceTable.vue?vue&type=template&id=e6796bac&scoped=true"
import script from "./ItemPriceTable.vue?vue&type=script&lang=ts"
export * from "./ItemPriceTable.vue?vue&type=script&lang=ts"
import style0 from "./ItemPriceTable.vue?vue&type=style&index=0&id=e6796bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6796bac",
  null
  
)

export default component.exports